import { render, staticRenderFns } from "./fund-two.vue?vue&type=template&id=0cf88abb&scoped=true&"
import script from "./fund-two.vue?vue&type=script&lang=js&"
export * from "./fund-two.vue?vue&type=script&lang=js&"
import style0 from "./fund-two.vue?vue&type=style&index=0&id=0cf88abb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf88abb",
  null
  
)

export default component.exports